module.exports = __webpack_public_path__ + "static/media/logo.e5775a3e.png";